export default class LiveTVStreamInfoResponse {
    constructor(resp) {
        this.url = null
        this.seriesTitle = null
        Object.assign(this, resp)
    }
}
